import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "919326800270";

export default function WhatsAppFloat() {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi! I'd like to learn more about The Indian Marketing's services."
  )}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[55] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-gold opacity-90" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg group-hover:scale-110 transition-transform duration-300">
        <MessageCircle size={26} strokeWidth={2.2} />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 hidden md:block bg-[#111111] border border-[#D4AF37]/40 text-white text-xs font-outfit uppercase tracking-[0.2em] px-3 py-2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        Chat on WhatsApp
      </span>
    </a>
  );
}
